import file from "../Markdown/ForOrganizations.md";
import React from "react";
import MarkdownPage from "../Layout/MarkdownPage";

function ForOrganizations() {
    return (<MarkdownPage title='Jesteś organizatorem?' file={file} />);
}

export default ForOrganizations;